/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=035f8cb3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=035f8cb3&lang=scss"

import exportComponent from "E:\\1018\\xuetangyi-front\\xuetangyi_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__